import React from 'react';
import { ShowButton } from '@refinedev/antd';
import { Space } from 'antd';
import { ColumnType } from '@/types';
import dayjs from 'dayjs';

export const getColumns = (
  translate: (key: string) => string
): ColumnType[] => [
  {
    title: translate('listing-contact-us.id'),
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: translate('listing-contact-us.name'),
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: translate('listing-contact-us.email'),
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: translate('listing-contact-us.organization_name'),
    dataIndex: 'organization_name',
    key: 'organization_name',
  },
  {
    title: translate('listing-contact-us.message'),
    dataIndex: 'message',
    key: 'message',
    render: (value) => (value ? `${value?.slice(0, 20)}...` : '-'),
  },
  {
    title: translate('listing-contact-us.created_at'),
    dataIndex: 'created_at',
    key: 'created_at',
    render: (value) => dayjs(value).format('DD/MM/YYYY HH:mm:ss'),
  },
  {
    title: translate('listing-contact-us.actions'),
    dataIndex: 'actions',
    key: 'actions',
    render: (_, record) => (
      <Space>
        <ShowButton recordItemId={record.id} hideText size="small" />
      </Space>
    ),
  },
];
